import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
const NoMatch = React.lazy(() => import("./views/NoMatch"));
const LoginPage = React.lazy(() => import("./views/login/LoginPage"));
const Home = React.lazy(() => import("./views/home/Home"));
const Administrator = React.lazy(
  () => import("./views/administrator/Administrator")
);
const AccessDenied = React.lazy(() => import("./views/AccessDenied"));

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import "./App.css";
import EditCardBI from "./views/administrator/editCardsBI/EditCardBI";

const App: React.FC = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <BrowserRouter>
          <Routes>
            <Route path="/">
              <Route index element={<Home />} />
              <Route path="administrador" element={<Administrator />} />
              <Route path="administrador/edit_card_bi" element={<EditCardBI />}/>
              <Route path="access-denied" element={<AccessDenied />} />
              <Route path="*" element={<NoMatch />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginPage />} />
          </Routes>
        </BrowserRouter>
      </UnauthenticatedTemplate>
    </>
  );
};

export default App;
